import { AdminRolesPage } from '@/features/admin/pages/AdminRolesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/roles')({
  component: AdminRolesPage,
});
